import { render } from "./GalleryPage.vue?vue&type=template&id=a1d64886&scoped=true"
import script from "./GalleryPage.vue?vue&type=script&lang=js"
export * from "./GalleryPage.vue?vue&type=script&lang=js"

import "./GalleryPage.vue?vue&type=style&index=0&id=a1d64886&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d64886"]])

export default __exports__